import React from 'react';
import { Card, CardContent, Typography, Chip, Stack } from '@mui/material';
import ResourceLinks from './ResourceLinks';

const boldName = 'Guillermo Tafoya Milo';

const renderAuthors = (authors) => {
  const list = Array.isArray(authors)
    ? authors
    : authors.split(',').map((author) => author.trim()).filter(Boolean);

  return list.map((author, index) => (
    <React.Fragment key={`${author}-${index}`}>
      {author === boldName ? <strong>{author}</strong> : author}
      {index < list.length - 1 ? ', ' : ''}
    </React.Fragment>
  ));
};

const AcademiaItem = ({
  badge,
  title,
  authors,
  eventOrSource,
  date,
  note,
  slides,
  media,
  document,
  certificate,
  poster,
  doi,
}) => (
  <Card
    elevation={0}
    sx={{
      marginBottom: 3,
      backgroundColor: 'rgba(15, 23, 42, 0.85)',
      border: '1px solid rgba(148, 163, 184, 0.18)',
    }}
  >
    <CardContent>
      <Stack spacing={1.5}>
        <Stack direction="row" alignItems="center" spacing={1.5}>
          {badge && (
            <Chip
              label={badge}
              size="small"
              color="primary"
              variant="outlined"
              sx={{
                borderColor: 'rgba(96,165,250,0.4)',
                backgroundColor: 'rgba(37, 99, 235, 0.08)',
                fontWeight: 600,
              }}
            />
          )}
          {date && (
            <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
              {date}
            </Typography>
          )}
        </Stack>

        {title && (
          <Typography variant="h6" sx={{ fontWeight: 600, color: 'text.primary', lineHeight: 1.4 }}>
            {title}
          </Typography>
        )}

        {authors && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {renderAuthors(authors)}
          </Typography>
        )}

        {eventOrSource && (
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {eventOrSource}
          </Typography>
        )}

        {note && (
          <Typography variant="body2" sx={{ color: 'text.secondary', fontStyle: 'italic' }}>
            {note}
          </Typography>
        )}

        <ResourceLinks
          slides={slides}
          media={media}
          document={document}
          certificate={certificate}
          poster={poster}
          doi={doi}
        />
      </Stack>
    </CardContent>
  </Card>
);

export default AcademiaItem;
